import styled, { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.95); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.sm ?? '8px'};
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-primary, ${(props) => props.theme.colors?.primary ?? '#2563eb'});
  animation: ${pulse} 1.2s ease-in-out infinite;
  flex-shrink: 0;
`;

export const Label = styled.span`
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? '14px'};
  color: ${(props) => props.theme.colors?.body ?? 'inherit'};
`;

export const KindBadge = styled.span`
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--color-neutral-100, rgba(0, 0, 0, 0.06));
  color: var(--color-body, #666);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
